"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetProductList = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _presentationUtils = require("@ori/presentation-utils");
var _useProductListParams = require("./useProductListParams");
/* istanbul ignore file */ const useGetProductList = ()=>{
    const { customerId } = (0, _auth.useToken)();
    const { tenant } = (0, _environment.useEnvironment)();
    const { productListId, productListType } = (0, _useProductListParams.useProductListParams)();
    return (0, _globalApiClientReact.useGetCustomerProductListTypeProductList)(customerId, productListType, productListId !== null && productListId !== void 0 ? productListId : '', {
        [_fetching.TENANT_CONTEXT]: tenant
    }, {
        swr: {
            enabled: productListId !== undefined,
            ...(0, _presentationUtils.getRetryErrorSwrOptions)()
        }
    });
};
exports.useGetProductList = useGetProductList;
